import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ProfileContainer from 'app/containers/Profile'

const ProfilePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.profile)}</PageTitle>
      <ProfileContainer />
    </>
  )
}
const ProfilePage = memo(ProfilePageCpn, isEqual)

export default ProfilePage
